define('plugin/promotion/view/PromotionModuleListView',['require','lib/view/BaseCompositeView','plugin/promotion/view/PromotionModuleItemView','lib/view/UnwrapBehavior'],function (require) {

    var Parent = require('lib/view/BaseCompositeView');
    var PromotionModuleItemView = require('plugin/promotion/view/PromotionModuleItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Promotion list module
     *
     * @class PromotionModuleListView
     */
    return Parent.extend({

        template: '#promotion_module_list_view',
        childView: PromotionModuleItemView,
        childViewContainer: '#sb_promotion_module_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },
        collectionEvents: {
            'sync': 'render'
        },

        limit: 4,
        _ids: [],

        _moduleId: 'promotion',

        initialize: function () {

        },

        filter: function (model) {
            if (_.indexOf(this._ids, model.get('id')) === -1) {
                return false;
            }
            return true;
        },

        onBeforeRender: function () {
            if (this.$el && this.$el.parent().length) {
                var count = this.$el.parent().data('sb-count');
                if (parseInt(count) && parseInt(count) != this.limit) {
                    this.limit = parseInt(count);
                }
            }

            this._ids = this.collection.pluck('id').slice(0, this.limit);
        }

    });

});
